/* Shared helpers for the Deal Jacket / Document Template pages. */
import { API } from "./api";

const TOKEN_KEY = "ssc_token";

/** Build a full URL — accepts either a path starting with `/api/...` (uses
 * BACKEND_URL only) or `/admin/...` (treated as relative to the API base). */
function _url(path) {
  if (!path) return API;
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("/api/")) return `${API.replace(/\/api$/, "")}${path}`;
  return `${API}${path}`;
}

export function authFetch(path, opts = {}) {
  const token = localStorage.getItem(TOKEN_KEY);
  return fetch(_url(path), {
    ...opts,
    headers: {
      ...(opts.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}

/** Fetch an auth-protected image/file as a blob URL so it can be used in <img src> / pdf canvas. */
export async function authBlobUrl(path) {
  const r = await authFetch(path);
  if (!r.ok) return null;
  const b = await r.blob();
  return URL.createObjectURL(b);
}

export const FIELD_TYPES = [
  { v: "text",      label: "Text" },
  { v: "date",      label: "Date" },
  { v: "checkbox",  label: "Checkbox" },
  { v: "signature", label: "Signature line" },
  { v: "initials",  label: "Initials" },
  { v: "notes",     label: "Multi-line notes" },
  { v: "dropdown",  label: "Dropdown" },
  { v: "currency",  label: "Currency" },
  { v: "number",    label: "Number" },
  { v: "phone",     label: "Phone" },
  { v: "email",     label: "Email" },
];
